"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJobsAll = exports.useJobs = exports.useRunStates = exports.useScriptTypes = void 0;
const react_1 = require("react");
const list_source_hook_1 = require("../../utils/list-source-hook");
const schedule_context_1 = require("./schedule-context");
function useScriptTypes() {
    return (0, list_source_hook_1.useStaticListSource)([
        { id: 'GROOVY', name: 'Groovy' },
        { id: 'JAVASCRIPT', name: 'Javascript' },
    ]);
}
exports.useScriptTypes = useScriptTypes;
function useRunStates() {
    return (0, list_source_hook_1.useStaticListSource)([
        { id: 'STARTED', name: 'Běží' },
        { id: 'ERROR', name: 'Chyba' },
        { id: 'FINISHED', name: 'Skončil' },
    ]);
}
exports.useRunStates = useRunStates;
function useJobs() {
    const { jobUrl } = (0, react_1.useContext)(schedule_context_1.ScheduleContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${jobUrl}/autocomplete/full`,
    });
}
exports.useJobs = useJobs;
function useJobsAll() {
    const { jobUrl } = (0, react_1.useContext)(schedule_context_1.ScheduleContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${jobUrl}/autocomplete/full/all`,
    });
}
exports.useJobsAll = useJobsAll;
//# sourceMappingURL=schedule-api.js.map